import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateUserRequest, UserRequest, UserResponse, UsersResponse, UserSearchRequest } from '../models/mxp-user.model';

@Injectable({ providedIn: 'root' })
export class MxpUserService {
  private readonly url = environment.identityUrl.replace(/\/$/, '') + '/api/mxp-users';
  constructor(private readonly http: HttpClient) {}
  getCurrentUser(): Observable<UserResponse> {
    return this.http.get<UserResponse>(this.url + '/current');
  }
  getUserById(request: { id?: string }): Observable<UserResponse> {
    return this.http.get<UserResponse>(this.userUrl(request.id));
  }
  getAllUsers(request: UserSearchRequest): Observable<UsersResponse> {
    const pagination = request.paginationData;
    const params = new HttpParams()
      .set('searchTerm', request.searchTerm || '')
      .set('pageIndex', String(pagination?.pageIndex ?? 0))
      .set('pageSize', String(pagination?.pageSize ?? 10))
      .set('sortField', pagination?.sortField || '')
      .set('sortDirection', String(pagination?.sortDirection ?? 0));
    return this.http.get<UsersResponse>(this.url, { params });
  }
  createUser(request: CreateUserRequest): Observable<void> {
    return this.http.post<void>(this.url, request);
  }
  updateUser(request: UserRequest): Observable<void> {
    return this.http.put<void>(this.userUrl(request.id), request);
  }
  deleteUser(request: { id?: string }): Observable<void> {
    return this.http.delete<void>(this.userUrl(request.id));
  }
  changePasswordRequest(request: { id?: string }): Observable<void> {
    return this.http.post<void>(this.userUrl(request.id) + '/change-password', {});
  }
  private userUrl(id?: string): string {
    return this.url + '/' + encodeURIComponent(id || '');
  }
}
